<ion-icon
    slot="slot"
    name="{{ value ? 'checkmark-circle-outline' : 'close-circle-outline' }}"
></ion-icon>
